import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { Link as RouterLink, Redirect } from 'react-router-dom';

import {
  Box,
  Paper,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  Button,
  IconButton,
  Collapse,
  Grid
} from '@material-ui/core';

import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IndeterminateCheckBoxIcon from '@material-ui/icons/IndeterminateCheckBox';

//Redux
import { useSelector, useDispatch } from "react-redux";
import { getUserDetails } from 'src/redux/actions/auth';
import { applyLoan } from 'src/redux/actions/user.actions';
import { CLEAR_MESSAGE, SET_MESSAGE } from 'src/redux/actions/types';


//My COmponent
import Rate from 'src/components/applications/Rate'
import LoanAgreement from 'src/components/applications/LoanAgreement'
import Steps from 'src/components/applications/Steps';
import Computations from 'src/components/applications/Computation';

import { validateApplication, validateLoans } from 'src/utils/functions'
import { staticMsg } from 'src/utils/constants'


const action = data => (
  <Button color="secondary" size="small"
  component={RouterLink}
  edge="end"
  size="small"
  to={data}
  >
    lorem ipsum dolorem
  </Button>
);


const LoanGen = (props) => {
  const history = useHistory();
  const token = localStorage.accessToken;
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.auth);
  const { calculator: { principal, rate, term, rateTerm, total, amortization } } = useSelector(state => state.data);

  const [isGen, setIsGen] = useState(false);
  const [isRes, setIsRes] = useState(false);
  const [error, setError] = useState({
    isComplete: false,
    isLoan: true
  });

  const handleSubmit = async () => {
    let { errors, valid } = validateLoans(user && user.loans && user.loans.lenth !== 0 ? user.loans : []);
    if(valid){
      if(user && user.isVerified){
        await dispatch(applyLoan({principal, rateTerm, term, rate, purpose: 'For personal use'}))
        .then(rs => {
          console.log(rs)
            dispatch(getUserDetails());
            return history.push('/app/dashboard')
        })
        .catch(err => {
          console.log(err)
        })
  
      } else {
        console.log('wewewew')
        dispatch({type: SET_MESSAGE, payload: {
          message: staticMsg.unVerified(),
          type: 'warning'
        }})
      }
    } 
  }

  const handleContinue = () => {
    let stat = user && user.status && user.status.requirements ? user.status.requirements : [];  
    let { errors, valid } = validateApplication(stat);
   
    if(!valid){
      dispatch({
        type: SET_MESSAGE,
        payload: errors
      })
      setError({...error, isComplete: false})
    } else {
     setIsRes(true);
     setError({...error, isComplete: true})

    }
}

   
   useEffect(() => {

     if(user && user.status && user.loans){
      let stat = user && user.status && user.status.requirements ? user.status.requirements : [];  
      let val1 = validateApplication(stat).valid;
      let val2 = validateLoans(user.loans).valid;
      return setError({...error, isLoan: val2, isComplete: val1})
    }
 }, [user])


   if (!token) {
    return <Redirect to="/login" />;
  }


  return (
    <Paper {...props}>
    <CardHeader title={<div className="d-flex"><Typography className="flex-grow-1">Loan Computation</Typography></div>} />
    <Divider />
   
   
   
   
    {/* <Steps/> */}
    <Collapse in={!isRes} timeout="auto" unmountOnExit>

        <Box
          sx={{
            display: 'block',
            justifyContent: 'center',
          }}
        >
         <Grid
container
        // spacing={1}
      >
           <Grid
          item
          lg={6}
          sm={6}
          xl={6}
          xs={12}
        >
           <Rate  />

          </Grid>
          <Grid
          item
          lg={6}
          sm={6}
          xl={6}
          xs={12}
        >
           <Computations  />

          </Grid>
          </Grid>

            <br/>
        </Box>
      <Divider/>
      <Box
          sx={{
            display: 'd-flex',
            justifyContent: 'center',
            p: 1
          }}
        >
          <Button variant="outlined" 
          color={error.isComplete ? 'primary' : 'secondary'}
          onClick={() => handleContinue()}>Continue</Button>
        </Box>
        </Collapse>

        <Collapse in={isRes} timeout="auto" unmountOnExit>
    <Box
  sx={{
    display: 'block',
    justifyContent: 'center',
  }}
>
  <IconButton className="m-1" onClick={() => setIsRes(false)}>
  <ArrowBackIcon color="primary" />
  </IconButton>
   <LoanAgreement />
    <br/>
</Box>
<Divider/>
<Box
  sx={{
    display: 'd-flex',
    justifyContent: 'center',
    p: 1
  }}
>
<Button className="mb-1" variant="outlined" size="small"
color={user && user.isVerified && error.isLoan ? 'success' : 'secondary'}
onClick={() => handleSubmit()}>Submit Application</Button>
</Box>
</Collapse>
    </Paper>
  );
};

export default LoanGen;
